import React from "react";
import UnderConstruction from "components/atomics/Lotties/UnderConstruction/UnderConstruction";

const Development: React.FC<{ label: string }> = (props) => {
  return (
    <div>
      <UnderConstruction label={props.label} />
    </div>
  );
};

export default Development;
